// Libs
import React from 'react';

const RoundDeviceName = props => <span>{props.resource.device_name}</span>;

export default RoundDeviceName;
